import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { ReviewPage } from '~/components/grading/review-page'
import { getGradeResultFn } from '~/functions/grading.functions'
import { gradingKeys, scopeOf } from '~/lib/query-keys'

export const Route = createFileRoute('/_authed/app/exams/$examId_/review/$submissionId')({
  // Another teacher's, another organisation's and a missing result all end in "not found"
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: gradingKeys.result(scopeOf(context.session), params.submissionId),
      queryFn: () => getGradeResultFn({ data: { submissionId: params.submissionId } }),
    }),
  // The tab says which student is open, so a teacher with several tabs can tell them apart
  head: ({ loaderData }) => ({
    meta: [
      {
        title: `${
          loaderData
            ? m.review_title({ number: String(loaderData.studentNumber) })
            : m.review_pdf_title()
        } - ${m.app_name()}`,
      },
    ],
  }),
  component: ReviewRoute,
})

function ReviewRoute() {
  const { examId, submissionId } = Route.useParams()
  return <ReviewPage examId={examId} submissionId={submissionId} />
}
